import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WindowLoadingComponent } from './window-loading.component';
import { ProgressSpinnerModule } from "../progress-spinner/progress-spinner.module";

@NgModule({
    declarations: [
        WindowLoadingComponent
    ],
    exports: [
        WindowLoadingComponent
    ],
    imports: [
        CommonModule,
        ProgressSpinnerModule
    ]
})
export class WindowLoadingModule { }
